import React, { useState, useMemo, useEffect, useLayoutEffect } from 'react';
import apis from '../../../../apis';
import './index.less';
import { CORE_INDICATORS, TOTAL_INDICATORS, getSummaryData, indexIdList } from './constant';
import FunelAndTrend from './funel-and-trend.js';
import { DropdownCheckboxGroup, GridSummary, Summary, SummaryCardTitle, SummaryCardIndex, SummaryCardDescription, ColorSummaryCard } from '@jd/jmtd-pro';
import { format } from '@jd/jmtd-tools/es/number';
import { Button, CardSection } from '@jd/jmtd';
import _ from 'lodash';
import { getJmtdValFormatter } from '@/pages/mvp-panel/participant-data/components/global-effect/config';
import PropTypes from 'prop-types';

const defaultIndicators = ['search_uv', 'search_item_piece', 'search_ord_deal_ord_amt', 'fo_uctr'];

function SummaryRender({ data, name, des, type, norms=[] }) {
  return (
    <ColorSummaryCard>
      <SummaryCardTitle info={des}>{name}</SummaryCardTitle>
      <SummaryCardIndex>{_.isNil(data) ? '--' : format(data, getJmtdValFormatter(type))}</SummaryCardIndex>
      {
        norms.map(item => (
          <SummaryCardDescription
            key={item.code}
            left={item.name}
            right={_.isNil(item.value) ? '--' :  format(Math.abs(item.value), getJmtdValFormatter(item.type))}
            ascend={item.value > 0}
            descend={item.value < 0}
          />
        ))
      }
    </ColorSummaryCard>
  );
}
SummaryRender.propTypes = {
  circle: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};


const FloorKeyIndicators = (props) => {
  const { conditions } = props;
  const [indicatorList, setIndicatorList] = useState([]);
  const [showDlg, setShowDlg] = useState(false);
  const [indicators, setIndicators] = useState(defaultIndicators);

  const indicatorSource = useMemo(() => {
    return CORE_INDICATORS;
  }, []);

  useEffect(() => {
    if (conditions.criteria && !showDlg) {
      let param = { indicators: indicators, modelId: '25aac3e5-f6e4-4eb8-aefc-9924a2c8d5d1', orders: {} };
      apis.platDataOneServiceQuery({ ...conditions, ...param }).then((res) => {
        const list = res?.data?.bos;
        setIndicatorList(list)
      });
    }
  }, [conditions, indicators, showDlg]);
  const summaryData = useMemo(() => getSummaryData(indicatorList, indicators), [indicatorList]);

  const changeIndicator = selected => {
    const selectedIndex = selected.slice();
    let indexFlat = selectedIndex.flat();
    indexFlat = _.intersection(indexIdList, indexFlat);
    setIndicators(indexFlat);
  };

  return (
    <>
      <div className="key-indicators">
        <div className="key-indicators-top">
          <div className="key-indicators-title">关键指标</div>
          <DropdownCheckboxGroup
            key={`${JSON.stringify(indicatorSource)}`}
            width={716}
            value={indicators}
            onChange={changeIndicator}
            data={indicatorSource}
            maxLength={4}
            resetValue={defaultIndicators}
          >
            <Button semantic='primary'>
              指标切换
            </Button>
          </DropdownCheckboxGroup>
        </div>
        <div className="key-indicator-con">
          <Summary
            data={summaryData}
            size={'small'}
            itemRender={SummaryRender}
            render={GridSummary}
          />
        </div>
      </div>
      <FunelAndTrend conditions={conditions} indicators={indicators} showDlg={showDlg} />
    </>
  );
};

export default FloorKeyIndicators;
